import { BaseController } from '../../../../../common/base/controller';
import _ from 'lodash';

export class ReceivingConfirmRequestController extends BaseController {
  constructor(
    controllerService,
    receivingService,
    confirmReceivingService
  ) {
    'ngInject';
    super({
      controllerService,
      receivingService,
      confirmReceivingService
    });

    // ATTENTION: This state is skipable by config, take a look
    // at the confirmRequest.state definition.
    if (this.skipState) {
      this.next();
      return;
    }
  }

  get ticketId() {
    return this.$stateParams.ticketId;
  }

  $onInit() {
    const { receivingService } = this;

    this.breadcrumbs = receivingService.states;
    this.warrantUrl = this.confirmReceivingService.getWarrantUrl(this.ticket.id);
  }

  back() {
    const { ticketId, receivingService } = this;
    let defaultState = receivingService.states[this.stateIndex - 1];
    let stateName = receivingService.prevState(this.stateIndex, defaultState);
    this.go(stateName, { ticketId });
  }

  next() {
    const { ticketId, receivingService } = this;
    let defaultState = receivingService.states[this.stateIndex + 1] || _.last(receivingService.states);
    let stateName = receivingService.nextState(this.stateIndex, defaultState);
    this.go(stateName, { ticketId });
  }

  confirm() {
    const { ticketId } = this;
    this.confirmReceivingService
      .confirmRequest({ ticketId })
      .then(() => this.next());
  }
}
